<template>
  <div class="newsletter-form">
    <ModalWindow
      :show="showModal"
      with-close-button
      @close="closeModal"
    >
      <div class="modal-wrapper">
        <div class="form-wrapper">
          <h3 class="form-title">
            Become an insider?
            <br />
            Get exclusive career
            <br />
            tips every week
          </h3>

          <p class="form-dsc">
            Subscribe to our newsletter and start achieving
            <br />
            your career goals now.
          </p>

          <form
            novalidate
            @submit.prevent="subscribe"
          >
            <InputGroup
              v-model="email"
              :disabled="pending"
              error-input-name="Email"
              type="email"
              class="email-input"
              :class="{
                error: showError,
              }"
              :success-message="successMessage"
              :error="showError"
              autocomplete="email"
              @enter-submit="subscribe"
            >
              Email
              <template #icon>
                <CheckCircleIconV2
                  v-if="showSuccessMessage"
                  class="check-icon"
                />
                <CircleWarningIcon
                  v-else-if="showError"
                  class="warning-icon"
                />
              </template>
            </InputGroup>

            <button
              :disabled="pending"
              class="proxify-btn proxify-btn-no-icon subscribe-button"
            >
              <SpinnerIcon v-if="pending" />
              Subscribe now
            </button>

            <p class="privacy-txt">
              We promise to never spam you. Read our
              <a
                href="/privacy"
                target="_blank"
                aria-label="Privacy Policy"
              >
                privacy policy.
              </a>
            </p>
          </form>
        </div>

        <div class="newsletter-bg">
          <NuxtPicture
            src="/images/newsletter/onur.png"
            class="author-pic"
            alt="author"
          />

          <h5 class="author-quote">
            "Proxify offers opportunities at companies that pay well, with
            exciting technologies. My work is challenging me to learn new
            things."
          </h5>

          <p class="author-name">Onur</p>

          <Glassdoor class="glassdoor" />
        </div>
      </div>
    </ModalWindow>
  </div>
</template>

<script>
import InputGroup from '~/components/Common/UI/InputGroup/InputGroup.vue';
import Glassdoor from '~/components/Common/Glassdoor/Glassdoor.vue';
import ModalWindow from '~/components/Common/UI/ModalWindow/ModalWindow.vue';
import CircleWarningIcon from '~/components/Common/Svg/CircleWarningIcon.vue';
import CheckCircleIconV2 from '~/components/Common/Svg/CheckCircleIconV2.vue';
import SpinnerIcon from '~/components/Common/Svg/SpinnerIcon.vue';
import { validateEmail } from '~/utils/helpers/validators';
import { useSubscriptionStore } from '~/stores/subscription';

export default {
  components: {
    ModalWindow,
    Glassdoor,
    InputGroup,
    SpinnerIcon,
    CheckCircleIconV2,
    CircleWarningIcon,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['closeModal'],
  data() {
    return {
      showSuccessMessage: false,
      email: '',
      isValidEmail: true,
      timeout: null,
      pending: false,
      formSubmitted: false,
      subscriptionStore: useSubscriptionStore(),
    };
  },
  computed: {
    showError() {
      return !this.isValidEmail && this.formSubmitted;
    },
    subscribed() {
      return this.$store.state.subscription.subscribed;
    },
    successMessage() {
      return this.showSuccessMessage
        ? 'Your email has been successfully added to our mailing list.'
        : '';
    },
  },
  watch: {
    showSuccessMessage(showSuccessMessage) {
      if (showSuccessMessage) {
        this.timeout = setTimeout(() => {
          this.$emit('closeModal');
        }, 3000);
      }
    },
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
  methods: {
    async subscribe() {
      this.formSubmitted = true;
      this.isValidEmail = validateEmail(this.email);

      if (!this.isValidEmail) {
        return;
      }

      this.pending = true;

      try {
        await this.subscriptionStore.subscribe({
          email: this.email,
          subscribedFrom: 'exit-intent-banner',
          recaptcha: await this.$recaptchaV3('newsletter_form'),
        });

        this.showSuccessMessage = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.pending = false;
      }
    },
    closeModal() {
      if (!this.showSuccessMessage && !this.subscriptionStore.subscribed) {
        this.subscriptionStore.setSubscribedForOneDay();
      }
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NewsletterForm.scss';
</style>
